<template>
    <div class="w-full h-34 relative overflow-visible">
        <svg
            width="280" height="280" viewBox="0 0 280 280" fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        >
            <g class="animate-glow origin-center [transform-box:fill-box]">
                <circle cx="140" cy="140" r="60" fill="#8867EB" fill-opacity="0.3" filter="url(#glow_blur)" />
                <circle cx="140" cy="140" r="40" fill="#A78BFF" fill-opacity="0.4" filter="url(#glow_blur_sm)" />
            </g>

            <defs>
                <filter id="glow_blur" x="0" y="0" width="280" height="280"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feGaussianBlur stdDeviation="40" />
                </filter>
                <filter id="glow_blur_sm" x="60" y="60" width="160" height="160"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feGaussianBlur stdDeviation="20" />
                </filter>
            </defs>
        </svg>

        <div class="relative z-10 flex size-full items-center justify-center">
            <div class="size-15 flex items-center justify-center bg-purple-60 dark:bg-blue-800 border border-purple-140 rounded-2">
                <AiIcon35x35 />
            </div>
        </div>
    </div>
</template>

<script setup>
import AiIcon35x35 from '@/components/icons/AI/AiIcon35x35.vue'
</script>
